import {
	MetricCaption,
	MetricCard,
	MetricLabel,
	MetricValue,
	MetricsGrid,
} from "../styles";

const MetricsStrip = ({ metrics, getMetricTone }) => {
	return (
		<MetricsGrid>
			{metrics.map(metric => (
				<MetricCard key={metric.key} $tone={getMetricTone(metric)}>
					<MetricLabel>{metric.label}</MetricLabel>
					<MetricValue>{metric.value}</MetricValue>
					{metric.caption ? (
						<MetricCaption>{metric.caption}</MetricCaption>
					) : null}
				</MetricCard>
			))}
		</MetricsGrid>
	);
};

export default MetricsStrip;
